import { Plus, Trash2 } from "lucide-react";
import { Field, SectionTitle, inputCls, labelCls } from "@/components/admin/fields";
import { ICONS } from "@/lib/icons";

const ICON_LABELS = {
  paw: "Paw", engine: "Wrench", headlight: "Headlight", shield: "Shield", buffer: "Buffer",
  sparkles: "Sparkles", droplets: "Droplets", wind: "Wind", sun: "Sun", gem: "Gem", car: "Car", armchair: "Seat",
};

export const AddOnEditor = ({ addOns, onChange }) => {
  const update = (i, patch) => onChange(addOns.map((a, idx) => (idx === i ? { ...a, ...patch } : a)));
  const remove = (i) => onChange(addOns.filter((_, idx) => idx !== i));
  const add = () => onChange([...addOns, { name: "", price: "", icon: "sparkles" }]);

  return (
    <section>
      <SectionTitle hint="Add, rename, re-price or remove extras. Up to 12.">Add-ons</SectionTitle>
      <div className="space-y-3">
        {addOns.map((a, i) => {
          const Icon = ICONS[a.icon] || ICONS.sparkles;
          return (
            <div
              key={i}
              data-testid={`admin-addon-row-${i}`}
              className="grid grid-cols-1 gap-3 border border-white/10 bg-[#0A0A0A] p-4 sm:grid-cols-[44px_1fr_110px_130px_40px] sm:items-end"
            >
              <span className="hidden h-[42px] w-[44px] items-center justify-center border border-[#E60000]/50 text-[#E60000] sm:flex">
                <Icon size={18} />
              </span>
              <Field
                label="Name"
                testId={`admin-addon-name-${i}`}
                value={a.name}
                maxLength={60}
                placeholder="Pet Hair Removal"
                onChange={(e) => update(i, { name: e.target.value })}
              />
              <Field
                label="Price"
                testId={`admin-addon-price-${i}`}
                value={a.price}
                maxLength={12}
                placeholder="$25+"
                onChange={(e) => update(i, { price: e.target.value })}
              />
              <label className="block">
                <span className={labelCls}>Icon</span>
                <select
                  data-testid={`admin-addon-icon-${i}`}
                  value={a.icon}
                  onChange={(e) => update(i, { icon: e.target.value })}
                  className={`${inputCls} appearance-none`}
                >
                  {Object.keys(ICONS).map((k) => (
                    <option key={k} value={k}>{ICON_LABELS[k] || k}</option>
                  ))}
                </select>
              </label>
              <button
                type="button"
                onClick={() => remove(i)}
                data-testid={`admin-addon-remove-${i}`}
                aria-label="Remove add-on"
                className="flex h-[42px] items-center justify-center border border-white/15 text-zinc-500 transition-[border-color,color] duration-300 hover:border-[#E60000] hover:text-[#E60000]"
              >
                <Trash2 size={16} />
              </button>
            </div>
          );
        })}
      </div>
      {addOns.length < 12 && (
        <button
          type="button"
          onClick={add}
          data-testid="admin-addon-add-button"
          className="mt-4 inline-flex items-center gap-2 border border-dashed border-white/20 px-5 py-3 font-display text-xs font-semibold uppercase tracking-[0.25em] text-zinc-300 transition-[border-color,color] duration-300 hover:border-[#E60000] hover:text-[#E60000]"
        >
          <Plus size={14} />
          Add an add-on
        </button>
      )}
    </section>
  );
};

export default AddOnEditor;
